import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import GeneratorApp from './embedGenerator/GeneratorApp';

// lazyLoading is creating small bundles with hashes in the filenames.
// It's impossible to give the users a filename like this:
// /static/js/main.js
// it will always be something like /static/js/main.27510c8d.js

import './index.css';

// Main AccessPlanIT widget
const container = document.getElementById('app');
if (container) {
  let companyIds, displayMode, categoryIds, courseIds, columnsToDisplay;
  columnsToDisplay = (!!container.getAttribute("data-columns-to-display"))? container.getAttribute("data-columns-to-display").split(', ') :[];
  companyIds = container.getAttribute("data-company-id").replace(/ /g, '').split(',');
  displayMode = container.getAttribute("data-display-mode") != null && container.getAttribute("data-display-mode") !== ""
    ? container.getAttribute("data-display-mode")
    : "basic"
  categoryIds = container.getAttribute("data-category-id")?.replace(/ /g, '').split(',') || [];
  courseIds = container.getAttribute("data-course-id")?.replace(/ /g, '').split(',') || [];

  const root = createRoot(container);
  // const App = lazy(() => import('./App'));
  root.render(
    <React.StrictMode>
      <App companyIds={companyIds} displayMode={displayMode}
        categoryIds={categoryIds} courseIds={courseIds} columnsToDisplay={columnsToDisplay} />
    </React.StrictMode>
  );
}


// Helper page to generate embed code
const generatorContainer = document.getElementById('embed-code-generator')
if (generatorContainer) {
  const generatorRoot = createRoot(generatorContainer);
  // const GeneratorApp = lazy(() => import('./embedGenerator/GeneratorApp'));
  generatorRoot.render(
    <React.StrictMode>
      <GeneratorApp />
    </React.StrictMode>
  )
}